<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <label class="form-label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <input
        :type="type"
        class="form-control"
        :placeholder="placeholder"
        v-model="valueProxy"
        :disabled="disabled"
    />
    <small class="text-danger">{{ errors[0] }}</small>
  </ValidationProvider>
</template>

<script>
  export default {
    name: "InputField",
    props: {
      label: String,
      value: [String, Number],
      placeholder: String,
      rules: String,
      required: Boolean,
      disabled: Boolean,
      type: {
        type: String,
        default: "text"
      }
    },
    computed: {
      valueProxy: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit("input", val);
        }
      }
    }
  };
</script>
